import standardLayoutRoute from '@input-web/modules/standard/views/layout/standard-layout.route';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

const standardListRoute = createRoute({
  component: lazyRouteComponent(() => import('./standard-list.view')),
  getParentRoute: () => standardLayoutRoute,
  path: '/standards',
});

export default standardListRoute;
